import { render, staticRenderFns } from "./Plain.vue?vue&type=template&id=1773ad11&"
import script from "./Plain.vue?vue&type=script&lang=js&"
export * from "./Plain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1773ad11')) {
      api.createRecord('1773ad11', component.options)
    } else {
      api.reload('1773ad11', component.options)
    }
    module.hot.accept("./Plain.vue?vue&type=template&id=1773ad11&", function () {
      api.rerender('1773ad11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Plain.vue"
export default component.exports